import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
var render = function render() {
  var _vm$currentTopInfoDat, _vm$currentTopInfoDat2, _vm$currentTopInfoDat3, _vm$currentTopInfoDat4, _vm$currentTopInfoDat5, _vm$currentTopInfoDat6, _vm$currentTopInfoDat7, _vm$currentTopInfoDat8, _vm$currentTopInfoDat9, _vm$currentTopInfoDat10, _vm$currentTopInfoDat11, _vm$currentTopInfoDat12, _vm$currentTopInfoDat13, _vm$currentTopInfoDat14, _vm$currentTopInfoDat15, _vm$currentTopInfoDat16, _vm$currentTopInfoDat17, _vm$currentTopInfoDat18, _vm$currentTopInfoDat19, _vm$currentTopInfoDat20, _vm$currentTopInfoDat21, _vm$currentTopInfoDat22, _vm$currentTopInfoDat23, _vm$currentTopInfoDat24, _vm$currentTopInfoDat25, _vm$currentTopInfoDat26, _vm$currentTopInfoDat27, _vm$currentTopInfoDat28, _vm$currentTopInfoDat29, _vm$currentTopInfoDat30, _vm$currentTopInfoDat31, _vm$currentTopInfoDat32, _vm$currentTopInfoDat33, _vm$currentTopInfoDat34, _vm$currentTopInfoDat35, _vm$currentTopInfoDat36;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "information-windows",
    attrs: {
      "id": "infoWindow"
    }
  }, [_c('div', {
    staticClass: "ifm-group"
  }, [_c('div', {
    staticClass: "ifm-group__top"
  }, [_c('div', {
    staticClass: "ifm-group__title"
  }, [_c('h4', [_vm._v(_vm._s(_vm.siteName))]), _c('p', [_vm._v("即時資訊 / " + _vm._s(_vm.siteType))])]), _vm._m(0)]), _c('div', {
    staticClass: "ifm-group__mid"
  }, [_vm.siteType === '太陽能' ? _c('div', {
    staticClass: "ifm-group__pv"
  }, [_c('div', {
    staticClass: "ifm-group__weather"
  }, [_vm.isDataLoading ? _c('div', {
    staticClass: "skeleton-block"
  }, [_c('v-skeleton-loader', {
    staticClass: "skeleton-weather-block",
    attrs: {
      "type": "rect"
    }
  })], 1) : _c('div', {
    staticClass: "ifm-group__weather-content"
  }, [_c('p', {
    staticClass: "ifm-group__weather-title"
  }, [_vm._v("今日天氣")]), _c('div', {
    staticClass: "ifm-group__weather-info"
  }, [_c('img', {
    staticClass: "ifm-group__weather-icon",
    staticStyle: {
      "height": "80px"
    },
    attrs: {
      "src": (_vm$currentTopInfoDat = _vm.currentTopInfoData) !== null && _vm$currentTopInfoDat !== void 0 && (_vm$currentTopInfoDat2 = _vm$currentTopInfoDat.weather) !== null && _vm$currentTopInfoDat2 !== void 0 && _vm$currentTopInfoDat2.icon ? require("@/assets/weather/".concat((_vm$currentTopInfoDat3 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat3 === void 0 ? void 0 : (_vm$currentTopInfoDat4 = _vm$currentTopInfoDat3.weather) === null || _vm$currentTopInfoDat4 === void 0 ? void 0 : _vm$currentTopInfoDat4.icon, ".png")) : '',
      "alt": (_vm$currentTopInfoDat5 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat5 === void 0 ? void 0 : (_vm$currentTopInfoDat6 = _vm$currentTopInfoDat5.weather) === null || _vm$currentTopInfoDat6 === void 0 ? void 0 : _vm$currentTopInfoDat6.icon
    }
  }), _c('p', {
    staticClass: "ifm-group__weather-status"
  }, [_vm._v(" " + _vm._s((_vm$currentTopInfoDat7 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat7 === void 0 ? void 0 : (_vm$currentTopInfoDat8 = _vm$currentTopInfoDat7.weather) === null || _vm$currentTopInfoDat8 === void 0 ? void 0 : _vm$currentTopInfoDat8.status) + " ")])]), _c('h3', {
    staticClass: "ifm-group__weather-temp"
  }, [_vm._v(" " + _vm._s(_vm.isNumber((_vm$currentTopInfoDat9 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat9 === void 0 ? void 0 : (_vm$currentTopInfoDat10 = _vm$currentTopInfoDat9.weather) === null || _vm$currentTopInfoDat10 === void 0 ? void 0 : _vm$currentTopInfoDat10.temp) ? Number((_vm$currentTopInfoDat11 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat11 === void 0 ? void 0 : (_vm$currentTopInfoDat12 = _vm$currentTopInfoDat11.weather) === null || _vm$currentTopInfoDat12 === void 0 ? void 0 : _vm$currentTopInfoDat12.temp).toFixed(1) : "-") + " "), _c('span', {
    staticClass: "ifm-group__weather-temp-unit"
  }, [_vm._v(_vm._s((_vm$currentTopInfoDat13 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat13 === void 0 ? void 0 : (_vm$currentTopInfoDat14 = _vm$currentTopInfoDat13.weather) === null || _vm$currentTopInfoDat14 === void 0 ? void 0 : _vm$currentTopInfoDat14.unit))])])])]), _c('div', {
    staticClass: "ifm-group__info-list"
  }, _vm._l((_vm$currentTopInfoDat15 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat15 === void 0 ? void 0 : _vm$currentTopInfoDat15.list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ifm-group__info-item"
    }, [_vm.isDataLoading ? _c('div', {
      staticClass: "skeleton-block"
    }, [_c('v-skeleton-loader', {
      staticClass: "skeleton-info-block",
      attrs: {
        "type": "rect"
      }
    })], 1) : _c('div', {
      staticClass: "ifm-group__info-content"
    }, [_c('div', {
      staticClass: "ifm-group__info-title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "ifm-group__info-data"
    }, [_vm._v(" " + _vm._s(item.value) + " "), _c('span', {
      staticClass: "ifm-group__info-unit"
    }, [_vm._v(_vm._s(item.unit))])])])]);
  }), 0)]) : _vm.siteType === '儲能' ? _c('div', {
    staticClass: "ifm-group__bess"
  }, [_c('div', {
    staticClass: "ifm-group__info-list"
  }, [_vm._l((_vm$currentTopInfoDat16 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat16 === void 0 ? void 0 : _vm$currentTopInfoDat16.list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ifm-group__info-item"
    }, [_vm.isDataLoading ? _c('div', {
      staticClass: "skeleton-block"
    }, [_c('v-skeleton-loader', {
      staticClass: "skeleton-info-block",
      attrs: {
        "type": "rect"
      }
    })], 1) : _c('div', {
      staticClass: "ifm-group__info-content"
    }, [_c('div', {
      staticClass: "ifm-group__info-title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "ifm-group__info-data"
    }, [_c('span', {
      staticClass: "ifm-group__info-value"
    }, [_vm._v(_vm._s(item.value))]), _c('span', {
      staticClass: "ifm-group__info-unit"
    }, [_vm._v(_vm._s(item.unit))])])])]);
  }), _c('div', {
    staticClass: "ifm-group__info-item"
  }, [_vm.isDataLoading ? _c('div', {
    staticClass: "skeleton-block"
  }, [_c('v-skeleton-loader', {
    staticClass: "skeleton-info-block",
    attrs: {
      "type": "rect"
    }
  })], 1) : _c('div', {
    staticClass: "ifm-group__info-content"
  }, [_c('div', {
    staticClass: "ifm-group__info-title"
  }, [_vm._v(" " + _vm._s((_vm$currentTopInfoDat17 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat17 === void 0 ? void 0 : (_vm$currentTopInfoDat18 = _vm$currentTopInfoDat17.status) === null || _vm$currentTopInfoDat18 === void 0 ? void 0 : _vm$currentTopInfoDat18.title) + " ")]), _c('div', {
    staticClass: "ifm-group__comm-status"
  }, _vm._l((_vm$currentTopInfoDat19 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat19 === void 0 ? void 0 : (_vm$currentTopInfoDat20 = _vm$currentTopInfoDat19.status) === null || _vm$currentTopInfoDat20 === void 0 ? void 0 : _vm$currentTopInfoDat20.commStatus, function (c, i) {
    return _c('p', {
      key: i
    }, [_c('span', {
      staticClass: "ifm-group__comm-status-name"
    }, [_vm._v(_vm._s(c.name))]), _c('span', {
      staticClass: "ifm-group__comm-status-status"
    }, [_vm._v(_vm._s(c.status))])]);
  }), 0)])])], 2)]) : _vm.siteType === '用電' ? _c('div', {
    staticClass: "ifm-group__electricity"
  }, [_c('div', {
    staticClass: "ifm-group__weather"
  }, [_vm.isDataLoading ? _c('div', {
    staticClass: "skeleton-block"
  }, [_c('v-skeleton-loader', {
    staticClass: "skeleton-weather-block",
    attrs: {
      "type": "rect"
    }
  })], 1) : _c('div', {
    staticClass: "ifm-group__weather-content"
  }, [_c('p', {
    staticClass: "ifm-group__weather-title"
  }, [_vm._v("今日天氣")]), _c('div', {
    staticClass: "ifm-group__weather-info"
  }, [_c('img', {
    staticClass: "ifm-group__weather-icon",
    staticStyle: {
      "height": "80px"
    },
    attrs: {
      "src": (_vm$currentTopInfoDat21 = _vm.currentTopInfoData) !== null && _vm$currentTopInfoDat21 !== void 0 && (_vm$currentTopInfoDat22 = _vm$currentTopInfoDat21.weather) !== null && _vm$currentTopInfoDat22 !== void 0 && _vm$currentTopInfoDat22.icon ? require("@/assets/weather/".concat((_vm$currentTopInfoDat23 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat23 === void 0 ? void 0 : (_vm$currentTopInfoDat24 = _vm$currentTopInfoDat23.weather) === null || _vm$currentTopInfoDat24 === void 0 ? void 0 : _vm$currentTopInfoDat24.icon, ".png")) : '',
      "alt": (_vm$currentTopInfoDat25 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat25 === void 0 ? void 0 : (_vm$currentTopInfoDat26 = _vm$currentTopInfoDat25.weather) === null || _vm$currentTopInfoDat26 === void 0 ? void 0 : _vm$currentTopInfoDat26.icon
    }
  }), _c('p', {
    staticClass: "ifm-group__weather-status"
  }, [_vm._v(" " + _vm._s((_vm$currentTopInfoDat27 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat27 === void 0 ? void 0 : (_vm$currentTopInfoDat28 = _vm$currentTopInfoDat27.weather) === null || _vm$currentTopInfoDat28 === void 0 ? void 0 : _vm$currentTopInfoDat28.status) + " ")])]), _c('h3', {
    staticClass: "ifm-group__weather-temp"
  }, [_vm._v(" " + _vm._s(_vm.isNumber((_vm$currentTopInfoDat29 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat29 === void 0 ? void 0 : (_vm$currentTopInfoDat30 = _vm$currentTopInfoDat29.weather) === null || _vm$currentTopInfoDat30 === void 0 ? void 0 : _vm$currentTopInfoDat30.temp) ? Number((_vm$currentTopInfoDat31 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat31 === void 0 ? void 0 : (_vm$currentTopInfoDat32 = _vm$currentTopInfoDat31.weather) === null || _vm$currentTopInfoDat32 === void 0 ? void 0 : _vm$currentTopInfoDat32.temp).toFixed(1) : "-") + " "), _c('span', {
    staticClass: "ifm-group__weather-temp-unit"
  }, [_vm._v(_vm._s((_vm$currentTopInfoDat33 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat33 === void 0 ? void 0 : (_vm$currentTopInfoDat34 = _vm$currentTopInfoDat33.weather) === null || _vm$currentTopInfoDat34 === void 0 ? void 0 : _vm$currentTopInfoDat34.unit))])])])]), _c('div', {
    staticClass: "ifm-group__electricity-table"
  }, [_vm.isDataLoading ? _c('div', {
    staticClass: "skeleton-block"
  }, [_c('v-skeleton-loader', {
    staticClass: "skeleton-electricity-table",
    attrs: {
      "type": "rect"
    }
  })], 1) : _c('div', {
    staticClass: "ifm-group__electricity-content"
  }, _vm._l((_vm$currentTopInfoDat35 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat35 === void 0 ? void 0 : _vm$currentTopInfoDat35.list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ifm-group__electricity-item"
    }, [_c('div', {
      staticClass: "ifm-group__electricity-title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "ifm-group__electricity-data"
    }, _vm._l(item.subItems, function (sub, i) {
      return _c('div', {
        key: i,
        staticClass: "ifm-group__electricity-row"
      }, [_c('span', {
        staticClass: "ifm-group__electricity-name"
      }, [_vm._v(" " + _vm._s(sub.name) + " ")]), _c('span', {
        staticClass: "ifm-group__electricity-value"
      }, [_vm._v(" " + _vm._s(sub.value) + " "), _c('span', {
        staticClass: "ifm-group__electricity-unit"
      }, [_vm._v(" " + _vm._s(sub.unit) + " ")])])]);
    }), 0)]);
  }), 0)])]) : _vm._e()]), _c('div', {
    staticClass: "ifm-group__bottom"
  }, [_c('p', {
    staticClass: "ifm-group__date"
  }, [_vm._v(_vm._s((_vm$currentTopInfoDat36 = _vm.currentTopInfoData) === null || _vm$currentTopInfoDat36 === void 0 ? void 0 : _vm$currentTopInfoDat36.updateTime))]), ['太陽能', '用電'].includes(_vm.siteType) ? _c('button', {
    staticClass: "ifm-group__analysis-btn",
    class: {
      disabled: _vm.isDataLoading
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isDataLoading
    },
    on: {
      "click": _vm.openModal
    }
  }, [_c('img', {
    staticClass: "ifm-group__analysis-icon",
    attrs: {
      "src": require("@/assets/SituationRoom_scss/src/open.svg"),
      "alt": "open-svg"
    }
  }), _c('p', {
    staticClass: "ifm-group__analysis-text"
  }, [_vm._v("資訊分析圖")])]) : _vm._e()])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "ifm-group__close-btn",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    staticClass: "ifm-group__close-icon",
    attrs: {
      "src": require("@/assets/SituationRoom_scss/src/close.svg"),
      "alt": "close-svg"
    }
  })]);
}];
export { render, staticRenderFns };